import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import { BrowserRouter } from "react-router-dom";
import { MuiThemeProvider } from "@shared";
import "./index.css";
import { Toaster } from 'sonner';
import { CartProvider } from "./Context/useCart.jsx";
import { ModelOpenProvider } from "./Context/modelContext.jsx"

// If you have Redux mode/Context, you can read it and pass mode="dark"/"light".
// For now, keep it simple:
createRoot(document.getElementById("root")).render(
  <MuiThemeProvider brand="user" mode="light">
    <BrowserRouter>
      <ModelOpenProvider>
        <CartProvider>
          <App />
        </CartProvider>
      </ModelOpenProvider>
      <Toaster
        position="top-right"
        closeButton
        duration={3000}
        richColors={false}
      />
    </BrowserRouter>
  </MuiThemeProvider>
);
